/**
 * Ray Pack Picker
 *
 * Pack-enabled products:
 * - Ray Pack Picker is the only source of truth.
 * - Horizon variant picker/product form are hidden by CSS.
 * - Ready pack adds one real pack SKU.
 * - Custom pack adds grouped single SKUs with bundle properties for cart grouping.
 * - Customization UI is compact inside Pack Picker, not separate section.
 */

(function () {
  'use strict';

  const SIZE_SKU_FIELDS_MAP = {
    '2XS/XS': ['sku_2xs_xs', 'sku_xs'],
    'XS': ['sku_xs'],
    'XS/S': ['sku_xs_s', 'sku_xs'],
    'S': ['sku_s'],
    'S/M': ['sku_s_m', 'sku_s'],
    'M': ['sku_m'],
    'M/L': ['sku_m_l', 'sku_m'],
    'L': ['sku_l'],
    'L/XL': ['sku_l_xl', 'sku_l'],
    'XL': ['sku_xl'],
    'XL/2XL': ['sku_xl_2xl', 'sku_xl'],
    'XXL': ['sku_xxl'],
    '2XL': ['sku_2xl'],
    '2XL/3XL': ['sku_2xl_3xl', 'sku_2xl'],
    '3XL': ['sku_3xl'],
    '4XL': ['sku_4xl'],
    '5XL': ['sku_5xl'],
    '39-42': ['sku_39_42'],
    '43-46': ['sku_43_46'],
  };

  const SIZE_ORDER = [
    '2XS/XS',
    'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL',
    'XL', 'XL/2XL', 'XXL', '2XL', '2XL/3XL', '3XL', '4XL', '5XL',
    '39-42', '43-46',
  ];

  const DEFAULT_LABELS = {
    quantity: 'Кількість:',
    color: 'Колір:',
    choosePack: 'Виберіть набір:',
    size: 'Розмір:',
    sizeGuide: 'Таблиця розмірів',
    customize: 'Кастомізувати',
    changeColor: 'Змінити колір',
    currentColor: 'Колір:',
    apply: 'Застосувати',
    chooseSize: 'Виберіть розмір',
    choosePackButton: 'Виберіть набір',
    chooseAllColors: 'Оберіть всі кольори',
    addToCart: 'Додати в кошик',
    addPackToCart: 'Додати набір у кошик',
    soldOut: 'Немає в наявності',
    unavailable: 'Недоступно',
    adding: 'Додається…',
    added: 'Додано ✓',
    yourPack: 'Ваш набір',
    changeColorHint: '| натисніть на колір, щоб змінити',
    unitLabel: 'Колір у наборі',
    selectSizeBeforeCustomize: 'Спочатку виберіть розмір, тоді зберіть набір.',
    noColorsForSize: 'Для цього розміру немає доступних кольорів.',
    colorUnavailable: 'Цей колір недоступний у вибраному розмірі.',
    chooseColorsForAllUnits: 'Обери кольори для всіх одиниць набору.',
    cannotFindVariants: 'Не вдалося знайти доступні варіанти для цього набору.',
    noActiveOptions: 'Немає активних варіантів.',
    showMorePacks: 'Показати більше наборів',
    collapsePacks: 'Згорнути набори',
    close: 'Закрити',
    unitAria: 'Змінити колір одиниці',
    unitFallback: 'Одиниця',
    fallbackError: 'Помилка. Спробуй ще раз.',
  };

  const NO_IMAGE_PATTERN = /no-image/i;
  const PACK_VISIBLE_LIMIT = 4;

  function init() {
    const picker = document.getElementById('ray-pack-picker');
    if (!picker) return;

    const variants = parseJSON('ray-pack-variants-data', []);
    const swatchData = parseJSON('ray-pack-swatches-data', []);
    const packColorImagesData = parseJSON('ray-pack-color-images-data', []);
    const allPackItems = parseJSON('ray-pack-items-data', []);
    const meta = parseJSON('ray-pack-meta', {});
    const labels = Object.assign({}, DEFAULT_LABELS, meta.labels || {});
    const currentLanguage = String(meta.locale || '').toLowerCase();
    const isRu = currentLanguage.includes('ru');
    const isUk = currentLanguage.includes('uk') || currentLanguage.includes('ua');

    if (!variants.length) {
      console.warn('[RayPackPicker] Variants JSON порожній.');
      return;
    }

    const configuredSingleLabel = meta.single_format_label || '1 шт';

const packItems = allPackItems
  .filter((item) => item.active === true)
  .sort((a, b) => (a.sort_order || 99) - (b.sort_order || 99));

const variantFormats = uniqueOrdered(variants.map((variant) => variant.option3));
const activePackFormats = uniqueOrdered(packItems.map((item) => item.format_label));

const singleFormatFromVariants =
  variantFormats.find((variantFormat) => {
    return !activePackFormats.some((packFormat) => formatLabelsMatch(variantFormat, packFormat));
  }) || configuredSingleLabel;

const SINGLE_LABEL = singleFormatFromVariants;

const singleVariants = variants.filter((variant) => {
  return formatLabelsMatch(variant.option3, SINGLE_LABEL);
});

const formats = [SINGLE_LABEL, ...activePackFormats].filter((format) => {
  return variantFormats.some((variantFormat) => formatLabelsMatch(variantFormat, format));
});

const colors = uniqueOrdered(singleVariants.map((variant) => variant.option1));

    const sizes = uniqueOrdered(variants.map((variant) => variant.option2)).sort((a, b) => {
      const ai = SIZE_ORDER.indexOf(a);
      const bi = SIZE_ORDER.indexOf(b);
      if (ai === -1 && bi === -1) return 0;
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });

    const swatchMap = {};
    swatchData.forEach((swatch) => {
      if (!swatch || !swatch.name) return;
      swatchMap[swatch.name] = swatch;
    });

    const packColorImageMap = {};
    packColorImagesData.forEach((item) => {
      if (!item || !item.color || !item.image) return;
      packColorImageMap[String(item.color).trim()] = item.image;
    });

    const singleVariantMap = new Map();
    singleVariants.forEach((variant) => {
      const key = buildVariantKey(variant.option1, variant.option2);
      const current = singleVariantMap.get(key);
      if (!current || (!current.available && variant.available)) {
        singleVariantMap.set(key, variant);
      }
    });

    const state = {
      format: null,
      color: null,
      packItem: null,
      size: null,
      variantId: null,
      isPackMode: false,
      customMode: false,
      customPackItemId: null,
      customSlots: [],
      activeCustomSlot: 0,
      modalSelectedColor: null,
      isAdding: false,
    };

    const formatTabsEl = picker.querySelector('#rpp-format-tabs');
    const singleColorEl = picker.querySelector('#rpp-single-color');
    const swatchesEl = picker.querySelector('#rpp-swatches');
    const packCardsEl = picker.querySelector('#rpp-pack-cards');
    const cardsGridEl = picker.querySelector('#rpp-cards-grid');
    const sizesEl = picker.querySelector('#rpp-sizes');
    const atcBtn = picker.querySelector('#rpp-atc-btn');
    const atcText = picker.querySelector('#rpp-atc-text');
    const errorEl = picker.querySelector('#rpp-error');
    const colorLabelEl = picker.querySelector('#rpp-color-label');
    const sizeLabelEl = picker.querySelector('#rpp-size-label');
    const sizeGuideBtn = picker.querySelector('#rpp-size-guide-link');
    const modalSizeGuideBtn = picker.querySelector('#rpp-modal-size-guide-link');

    const customBundleEl = picker.querySelector('#rpp-custom-bundle');
    const customCountEl = picker.querySelector('#rpp-custom-count');
    const customSlotsEl = picker.querySelector('#rpp-custom-slots');

    const modalEl = picker.querySelector('#rpp-custom-modal');
    const modalImageEl = picker.querySelector('#rpp-modal-image');
    const modalSlotLabelEl = picker.querySelector('#rpp-modal-slot-label');
    const modalColorLabelEl = picker.querySelector('#rpp-modal-color-label');
    const modalColorsEl = picker.querySelector('#rpp-modal-colors');
    const modalApplyBtn = picker.querySelector('#rpp-modal-apply');

    document.documentElement.classList.add('ray-pack-active');

    renderFormatTabs();
    renderSwatches();
    renderSizes();
    bindModalEvents();
    initSizeGuideProxy();

    moveFitSwitchAfterSizeSection();
    selectInitialFormatTab();



    function moveFitSwitchAfterSizeSection() {
      const sizeSection = picker.querySelector('#rpp-size-section');

      if (!sizeSection) return;

      const productSection =
        picker.closest('[id^="shopify-section-"]') ||
        picker.closest('section') ||
        document;

      const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

      const hasFitText = (node) => {
        const text = normalizeText(node && node.textContent);

        if (!text) return false;
        if (!text.includes('посадка')) return false;

        return text.includes('змінити') ||
          text.includes('изменить') ||
          text.includes('стандартна') ||
          text.includes('оверсайз') ||
          text.includes('oversize') ||
          text.includes('standard');
      };

      const allCandidates = Array.from(productSection.querySelectorAll('div, p, section, product-info-block, custom-option, fieldset'))
        .filter((node) => {
          if (!node || node === picker || picker.contains(node)) return false;
          if (node.closest('#ray-pack-picker')) return false;
          if (node.matches('product-price, product-price *')) return false;
          // Excluded explicitly: a "Посадка" ray-key-fact whose own value is literally
          // "Оверсайз"/"Стандартна" text-matches hasFitText() just like the real fit-switch
          // block does, and being short-text it wins getBlockCandidate()'s "shortest match"
          // pick - misrelocating the whole key-facts row after the size section instead.
          if (node.closest('[data-ray-key-facts]')) return false;

          return hasFitText(node);
        });

      if (!allCandidates.length) return;

      const getBlockCandidate = (node) => {
        let current = node;

        while (current && current !== productSection && current.parentElement) {
          const parent = current.parentElement;

          if (parent === productSection || parent.contains(picker)) break;
          if (!hasFitText(parent)) break;

          const style = window.getComputedStyle(parent);
          const rect = parent.getBoundingClientRect();

          if (
            style.display !== 'inline' &&
            style.display !== 'contents' &&
            rect.width >= 180 &&
            rect.height > 0 &&
            rect.height <= 140
          ) {
            current = parent;
          } else {
            break;
          }
        }

        return current;
      };

      let fitBlock = null;

      for (const candidate of allCandidates) {
        const block = getBlockCandidate(candidate);
        const rect = block.getBoundingClientRect();

        if (
          block &&
          block.parentElement &&
          !block.contains(picker) &&
          !picker.contains(block) &&
          rect.width >= 180 &&
          rect.height > 0 &&
          rect.height <= 140
        ) {
          if (!fitBlock || normalizeText(block.textContent).length < normalizeText(fitBlock.textContent).length) {
            fitBlock = block;
          }
        }
      }

      if (!fitBlock || !fitBlock.parentElement || fitBlock === sizeSection || sizeSection.contains(fitBlock)) return;

      fitBlock.classList.add('rpp-fit-switch--moved-after-size');
      sizeSection.insertAdjacentElement('afterend', fitBlock);
    }


    function selectInitialFormatTab() {
      const preferredPackCount = getPreferredInitialPackCount();
      const preferredTab = findFormatTabByPackCount(preferredPackCount);

      if (preferredTab) {
        preferredTab.click();
        return;
      }

      const firstPackTab = Array.from(formatTabsEl.querySelectorAll('.rpp-format-tab')).find((tab) => {
        return !formatLabelsMatch(tab.dataset.format, SINGLE_LABEL);
      });

      if (firstPackTab) {
        firstPackTab.click();
        return;
      }

      const firstTab = formatTabsEl.querySelector('.rpp-format-tab');
      if (firstTab) firstTab.click();
    }

    function getPreferredInitialPackCount() {
      const source = [
        window.location.pathname,
        window.location.search,
        document.title,
        document.querySelector('h1')?.textContent || '',
        variants.map((variant) => variant.sku).join(' '),
        variants.map((variant) => variant.option1).join(' '),
        variants.map((variant) => variant.option2).join(' '),
        variants.map((variant) => variant.option3).join(' '),
      ].join(' ').toLowerCase();

      if (/(^|[^0-9])0102([^0-9]|$)|u0102/.test(source)) return 7;
      if (/(^|[^0-9])0104([^0-9]|$)|u0104/.test(source)) return 4;
      if (/(^|[^0-9])9060([^0-9]|$)/.test(source)) return 3;
      if (/(^|[^0-9])0701([^0-9]|$)|u0701/.test(source)) return 3;

      return 2;
    }

    function findFormatTabByPackCount(packCount) {
      const tabs = Array.from(formatTabsEl.querySelectorAll('.rpp-format-tab'));

      return tabs.find((tab) => {
        const format = tab.dataset.format || tab.textContent || '';

        if (formatLabelsMatch(format, SINGLE_LABEL)) return false;

        return inferPackCountFromLabel(format) === packCount;
      }) || null;
    }

    function renderFormatTabs() {
      formatTabsEl.innerHTML = '';
      formatTabsEl.classList.remove('has-slider', 'is-at-start', 'is-at-end');

      const viewport = el('div', { class: 'rpp-format-viewport' });
      const track = el('div', { class: 'rpp-format-track' });

      formats.forEach((format) => {
        const saveText = getFormatSaveText(format);
        const savePrefix = getFormatSavePrefix();
        const displayLabel = getDisplayFormatLabel(format);
        const btn = el('button', {
          class: 'rpp-format-tab',
          type: 'button',
          'data-format': format,
          'aria-pressed': 'false',
          'aria-label': saveText ? `${displayLabel}. ${savePrefix} ${saveText}` : displayLabel,
        });

        btn.appendChild(el('span', { class: 'rpp-format-title' }, displayLabel));

        if (saveText) {
          btn.appendChild(el('span', {
            class: 'rpp-format-save',
            'data-save-prefix': savePrefix,
          }, saveText));
        }

        btn.addEventListener('click', () => onFormatClick(format, btn));
        track.appendChild(btn);
      });

      viewport.appendChild(track);
      formatTabsEl.appendChild(viewport);
      initFormatTabsSlider(viewport, track);
    }

    function initFormatTabsSlider(viewport, track) {
      if (!viewport || !track) return;

      const prevBtn = createFormatSliderButton('prev');
      const nextBtn = createFormatSliderButton('next');

      formatTabsEl.appendChild(prevBtn);
      formatTabsEl.appendChild(nextBtn);

      const getStep = () => {
        const firstTab = track.querySelector('.rpp-format-tab');
        const secondTab = firstTab ? firstTab.nextElementSibling : null;

        if (firstTab && secondTab) {
          return Math.max(1, secondTab.offsetLeft - firstTab.offsetLeft);
        }

        return firstTab ? Math.max(1, firstTab.getBoundingClientRect().width) : 1;
      };

      const getMaxScroll = () => {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      };

      const updateSliderButtons = () => {
        const maxScroll = getMaxScroll();
        const hasOverflow = maxScroll > 2;
        const isStart = !hasOverflow || viewport.scrollLeft <= 2;
        const isEnd = !hasOverflow || viewport.scrollLeft >= maxScroll - 2;

        formatTabsEl.classList.toggle('has-slider', hasOverflow);
        formatTabsEl.classList.toggle('is-at-start', isStart);
        formatTabsEl.classList.toggle('is-at-end', isEnd);

        prevBtn.hidden = !hasOverflow;
        nextBtn.hidden = !hasOverflow;
        prevBtn.disabled = isStart;
        nextBtn.disabled = isEnd;

        if (!hasOverflow && viewport.scrollLeft !== 0) {
          viewport.scrollLeft = 0;
        }
      };

      const scrollOneTab = (direction) => {
        const step = getStep();
        const maxScroll = getMaxScroll();
        const currentIndex = Math.round(viewport.scrollLeft / step);
        const nextIndex = Math.max(0, currentIndex + direction);
        const target = Math.min(maxScroll, nextIndex * step);

        viewport.scrollTo({
          left: target,
          behavior: 'smooth',
        });
      };

      prevBtn.addEventListener('click', () => scrollOneTab(-1));
      nextBtn.addEventListener('click', () => scrollOneTab(1));
      viewport.addEventListener('scroll', updateSliderButtons, { passive: true });

      if (formatTabsEl._rppFormatResizeObserver) {
        formatTabsEl._rppFormatResizeObserver.disconnect();
      }

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(updateSliderButtons);
        resizeObserver.observe(viewport);
        resizeObserver.observe(track);
        formatTabsEl._rppFormatResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', updateSliderButtons);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(updateSliderButtons);
      });
    }

    function createFormatSliderButton(direction) {
      const isPrev = direction === 'prev';
      const label = isPrev
        ? (isRu ? 'Предыдущие варианты количества' : 'Попередні варіанти кількості')
        : (isRu ? 'Следующие варианты количества' : 'Наступні варіанти кількості');

      return el('button', {
        class: `rpp-pack-slider-btn rpp-pack-slider-btn--${direction} rpp-format-slider-btn rpp-format-slider-btn--${direction}`,
        type: 'button',
        'aria-label': label,
        title: label,
      }, isPrev ? '‹' : '›');
    }

    function ensureFormatTabVisible(tab) {
      if (!tab) return;

      const viewport = tab.closest('.rpp-format-viewport');
      if (!viewport) return;

      const viewportLeft = viewport.scrollLeft;
      const viewportRight = viewportLeft + viewport.clientWidth;
      const tabLeft = tab.offsetLeft;
      const tabRight = tabLeft + tab.offsetWidth;

      if (tabLeft < viewportLeft) {
        viewport.scrollTo({ left: tabLeft, behavior: 'smooth' });
      } else if (tabRight > viewportRight) {
        viewport.scrollTo({
          left: Math.max(0, tabRight - viewport.clientWidth),
          behavior: 'smooth',
        });
      }
    }

    function renderSwatches() {
      swatchesEl.innerHTML = '';

      colors.forEach((color) => {
        const btn = createRoundSwatchButton(color, 'rpp-swatch', 'rpp-swatch-inner');
        btn.addEventListener('click', () => onColorClick(color, btn));
        swatchesEl.appendChild(btn);
      });
    }

    function renderSizes() {
      sizesEl.innerHTML = '';

      sizes.forEach((size) => {
        const btn = el('button', {
          class: 'rpp-size-btn',
          type: 'button',
          'data-size': size,
          'aria-pressed': 'false',
        }, size);

        btn.addEventListener('click', () => onSizeClick(size, btn));
        sizesEl.appendChild(btn);
      });
    }

    function initSizeGuideProxy() {
      const proxyButtons = [sizeGuideBtn, modalSizeGuideBtn].filter(Boolean);

      if (!proxyButtons.length) return;

      const nativeSizeGuideTrigger = findNativeSizeGuideTrigger();

      if (!nativeSizeGuideTrigger) {
        proxyButtons.forEach((btn) => {
          btn.hidden = true;
        });
        return;
      }

      proxyButtons.forEach((btn) => {
        btn.hidden = false;
        btn.textContent = labels.sizeGuide;

        btn.addEventListener('click', (event) => {
          event.preventDefault();
          nativeSizeGuideTrigger.click();
        });
      });
    }

    function findNativeSizeGuideTrigger() {
      const candidates = Array.from(
        document.querySelectorAll('button, a, summary, [role="button"]')
      );

      return candidates.find((node) => {
        if (!node || node === sizeGuideBtn || node === modalSizeGuideBtn) return false;
        if (picker.contains(node)) return false;

        const text = (node.textContent || '').trim().toLowerCase();

        return (
          text.includes('таблиця розмірів') ||
          text.includes('таблица размеров') ||
          text.includes('size guide')
        );
      });
    }

    function renderPackCards(formatLabel) {
      cardsGridEl.innerHTML = '';
      cardsGridEl.classList.remove('has-toggle', 'is-collapsed', 'is-expanded', 'has-slider', 'is-at-start', 'is-at-end');

      const items = packItems.filter((item) => formatLabelsMatch(item.format_label, formatLabel));

      if (!items.length) {
        cardsGridEl.innerHTML = `<p class="rpp-no-cards">${labels.noActiveOptions}</p>`;
        return;
      }

      const customizableItems = items.filter((item) => item.customizable === true);
      let readyItems = items.filter((item) => item.customizable !== true);
      const customSourceItem = customizableItems[0] || null;

      // Backwards compatibility: if old metaobjects have customizable=true on every ready pack,
      // still show them as ready packs and use the first one as the separate custom-pack card.
      if (!readyItems.length && customSourceItem) {
        readyItems = items;
      }

      const orderedCards = [];

      if (customSourceItem) {
        orderedCards.push(createCustomPackCard(customSourceItem));
      }

      readyItems.forEach((item) => {
        orderedCards.push(createPackCard(item));
      });

      const viewport = el('div', { class: 'rpp-cards-viewport' });
      const track = el('div', { class: 'rpp-cards-track' });

      orderedCards.forEach((card) => {
        track.appendChild(card);
      });

      viewport.appendChild(track);
      cardsGridEl.appendChild(viewport);

      const prevBtn = createPackSliderButton('prev');
      const nextBtn = createPackSliderButton('next');

      cardsGridEl.appendChild(prevBtn);
      cardsGridEl.appendChild(nextBtn);

      const getStep = () => {
        const firstCard = track.querySelector('.rpp-pack-card');
        const secondCard = firstCard ? firstCard.nextElementSibling : null;

        if (firstCard && secondCard) {
          return Math.max(1, secondCard.offsetLeft - firstCard.offsetLeft);
        }

        return firstCard ? Math.max(1, firstCard.getBoundingClientRect().width) : 1;
      };

      const getMaxScroll = () => {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      };

      const updateSliderButtons = () => {
        const maxScroll = getMaxScroll();
        const hasOverflow = maxScroll > 2;
        const isStart = !hasOverflow || viewport.scrollLeft <= 2;
        const isEnd = !hasOverflow || viewport.scrollLeft >= maxScroll - 2;

        if (isStart && viewport.scrollLeft !== 0) {
          viewport.scrollLeft = 0;
        }

        cardsGridEl.classList.toggle('has-slider', hasOverflow);
        cardsGridEl.classList.toggle('is-at-start', isStart);
        cardsGridEl.classList.toggle('is-at-end', isEnd);

        prevBtn.hidden = !hasOverflow;
        nextBtn.hidden = !hasOverflow;
        prevBtn.disabled = isStart;
        nextBtn.disabled = isEnd;
      };

      const scrollOneCard = (direction) => {
        const step = getStep();
        const maxScroll = getMaxScroll();

        if (maxScroll <= 2 || step <= 0) return;

        const target = Math.max(
          0,
          Math.min(maxScroll, viewport.scrollLeft + direction * step)
        );

        viewport.scrollLeft = target;
        updateSliderButtons();

        requestAnimationFrame(updateSliderButtons);
      };

      let lastCardArrowClickAt = 0;

      const bindCardArrow = (button, direction) => {
        const handler = (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          const now = Date.now();

          if (now - lastCardArrowClickAt < 180) return;

          lastCardArrowClickAt = now;
          scrollOneCard(direction);
        };

        button.addEventListener('pointerdown', handler);
        button.addEventListener('touchstart', handler, { passive: false });
        button.addEventListener('click', handler);
      };

      bindCardArrow(prevBtn, -1);
      bindCardArrow(nextBtn, 1);

      viewport.addEventListener('scroll', updateSliderButtons, { passive: true });

      if (cardsGridEl._rppCardsResizeObserver) {
        cardsGridEl._rppCardsResizeObserver.disconnect();
      }

      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(updateSliderButtons);
        resizeObserver.observe(viewport);
        resizeObserver.observe(track);
        cardsGridEl._rppCardsResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', updateSliderButtons);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(updateSliderButtons);
      });
    }

    function createPackCard(item) {
      const card = el('button', {
        class: 'rpp-pack-card',
        type: 'button',
        'data-item-id': item.id,
        'aria-pressed': 'false',
      });

      const inner = el('div', { class: 'rpp-card-inner' });

      if (item.image) {
        inner.appendChild(el('img', {
          src: item.image,
          alt: item.title || '',
          class: 'rpp-card-img',
          width: '220',
          height: '220',
          loading: 'lazy',
        }));
      } else {
        const placeholder = el('div', {
          class: 'rpp-card-img rpp-card-img--placeholder',
        });
        placeholder.textContent = item.title || '';
        inner.appendChild(placeholder);
      }

      card.appendChild(inner);
      card.addEventListener('click', () => onPackCardClick(item, card));
      return card;
    }

    function createCustomPackCard(item) {
      const label = isRu ? 'Собери сам' : 'Збери сам';

      const card = el('button', {
        class: 'rpp-pack-card rpp-pack-card--custom',
        type: 'button',
        'data-item-id': item.id,
        'data-custom-pack-card': 'true',
        'aria-pressed': 'false',
      });

      const inner = el('div', { class: 'rpp-card-inner rpp-card-inner--custom' });

      inner.appendChild(el('span', {
        class: 'rpp-custom-pack-icon',
        'aria-hidden': 'true',
      }, '+'));

      inner.appendChild(el('span', {
        class: 'rpp-custom-pack-title',
      }, label));

      card.appendChild(inner);
      card.addEventListener('click', () => openCustomPack(item, card));
      return card;
    }

    function createPackSliderButton(direction) {
      const isPrev = direction === 'prev';

      return el('button', {
        class: `rpp-pack-slider-btn rpp-pack-slider-btn--${direction}`,
        type: 'button',
        'aria-label': isPrev ? labels.collapsePacks : labels.showMorePacks,
        title: isPrev ? labels.collapsePacks : labels.showMorePacks,
      }, isPrev ? '‹' : '›');
    }

    function onFormatClick(format, btn) {
      setActive(formatTabsEl, '.rpp-format-tab', btn);
      ensureFormatTabVisible(btn);

      state.format = format;
      state.isPackMode = !formatLabelsMatch(format, SINGLE_LABEL);
      picker.dataset.packMode = state.isPackMode ? 'true' : 'false';
      state.size = null;
      state.variantId = null;
      state.packItem = null;
      state.customMode = false;
      state.customPackItemId = null;
      state.customSlots = [];
      state.activeCustomSlot = 0;

      hideCustomBundle();
      closeCustomModal();

      sizeLabelEl.textContent = '';
      clearActive(sizesEl, '.rpp-size-btn');
      clearError();

      if (state.isPackMode) {
        singleColorEl.hidden = true;
        packCardsEl.hidden = false;
        renderPackCards(format);
        updatePackPricePreview(format);
      } else {
        packCardsEl.hidden = true;
        singleColorEl.hidden = false;

        const activeColor = swatchesEl.querySelector('.rpp-swatch.is-active');

        if (activeColor) {
          state.color = activeColor.dataset.color;
          colorLabelEl.textContent = state.color;

          const previewVariant = getSinglePreviewVariant(state.color);

          if (previewVariant) {
            updateHorizonPrice(previewVariant);
            switchGalleryImage(previewVariant);
          }
        } else {
          const firstColorBtn = swatchesEl.querySelector('.rpp-swatch');
          if (firstColorBtn) firstColorBtn.click();
        }
      }

      updateSizeAvailability();
      updateAtcState();
    }

    function onColorClick(color, btn) {
      setActive(swatchesEl, '.rpp-swatch', btn);

      state.color = color;
      state.variantId = null;
      state.customMode = false;
      state.customPackItemId = null;
      state.customSlots = [];

      hideCustomBundle();
      closeCustomModal();

      colorLabelEl.textContent = color;
      clearError();
      updateSizeAvailability();

      const previewVariant = getSinglePreviewVariant(color);

      if (previewVariant) {
        updateHorizonPrice(previewVariant);
        switchGalleryImage(previewVariant);
      }

      if (state.size) resolveVariant();

      updateAtcState();
    }

    function onPackCardClick(item, card) {
      setActive(cardsGridEl, '.rpp-pack-card', card);

      state.packItem = item;
      state.variantId = null;
      state.customMode = false;
      state.customPackItemId = null;
      state.customSlots = [];

      hideCustomBundle();
      closeCustomModal();

      clearError();
      updateSizeAvailability();

      previewPackImage(item);
      updatePackPricePreview(state.format, item);

      if (state.size) resolveVariant();

      updateAtcState();
    }

    function openCustomPack(item, card) {
      if (!item || !item.customizable) return;

      setActive(cardsGridEl, '.rpp-pack-card', card);

      state.packItem = item;
      state.variantId = null;

      updatePackPricePreview(state.format, item);

      clearError();
      updateSizeAvailability();

      if (!state.size) {
        state.customMode = false;
        state.customPackItemId = null;
        state.customSlots = [];

        hideCustomBundle();
        showError(labels.selectSizeBeforeCustomize);

        const sizeSection = picker.querySelector('#rpp-size-section');

        if (sizeSection) {
          sizeSection.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }

        updateAtcState();
        return;
      }

      const availableColors = getAvailableColorsForSize(state.size);

      if (!availableColors.length) {
        state.customMode = false;
        state.customPackItemId = null;
        state.customSlots = [];

        hideCustomBundle();
        showError(labels.noColorsForSize);
        updateAtcState();
        return;
      }

      const packCount = Math.max(
  1,
  inferPackCountFromLabel(state.format) ||
  Number(item.pack_count) ||
  1
);
      const shouldReset =
        !state.customMode ||
        state.customPackItemId !== item.id ||
        state.customSlots.length !== packCount;

      state.customMode = true;
      state.customPackItemId = item.id;
      state.activeCustomSlot = 0;

      if (shouldReset) {
        state.customSlots = Array.from({ length: packCount }, () => null);
      } else {
        state.customSlots = state.customSlots.map((color) => {
          return color && isColorAvailableForSize(color, state.size) ? color : null;
        });
      }

      renderCustomBundle();
      previewCustomPackImage();
      updateAtcState();
    }

    function onSizeClick(size, btn) {
      if (btn.disabled) return;

      setActive(sizesEl, '.rpp-size-btn', btn);

      state.size = size;
      state.variantId = null;

      sizeLabelEl.textContent = size;
      clearError();

      if (state.customMode) {
        normalizeCustomSlotsForSize();
        renderCustomBundle();
        previewCustomPackImage();
      }

      resolveVariant();
      updateFormatTabSavings();
      updateAtcState();
    }

    function updatePackPricePreview(formatLabel, item = null) {
      if (!formatLabel || formatLabelsMatch(formatLabel, SINGLE_LABEL)) return;

      const previewVariant = getPackPreviewVariant(formatLabel, item);

      if (previewVariant) {
        updateHorizonPrice(previewVariant, item, formatLabel);
      }
    }

    function getPackPreviewVariant(formatLabel, item = null) {
      if (!formatLabel) return null;

      if (item) {
        const sizeCandidates = uniqueOrdered([state.size, ...sizes].filter(Boolean));

        for (const size of sizeCandidates) {
          const sku = getSkuFromPackItem(item, size);
          if (!sku) continue;

          const variant = variants.find((v) => {
            return String(v.sku).trim() === sku && v.available;
          });

          if (variant) return variant;
        }

        for (const size of sizeCandidates) {
          const sku = getSkuFromPackItem(item, size);
          if (!sku) continue;

          const variant = variants.find((v) => {
            return String(v.sku).trim() === sku;
          });

          if (variant) return variant;
        }
      }

      return (
        variants.find((variant) => {
          return formatLabelsMatch(variant.option3, formatLabel) && variant.available;
        }) ||
        variants.find((variant) => {
          return formatLabelsMatch(variant.option3, formatLabel);
        }) ||
        null
      );
    }

    function resolveVariant() {
      if (!state.size || !state.format) return;

      let found = null;

      if (!state.isPackMode) {
        if (!state.color) return;

        found = variants.find((variant) => {
          return (
            variant.option1 === state.color &&
            variant.option2 === state.size &&
            formatLabelsMatch(variant.option3, state.format)
          );
        });
      } else {
        if (!state.packItem) return;

        const sku = getSkuFromPackItem(state.packItem, state.size);

        if (!sku) {
          console.warn('[RayPackPicker] SKU порожній для розміру:', state.size, state.packItem.title);
          return;
        }

        found = variants.find((variant) => String(variant.sku).trim() === sku);

        if (!found) {
          console.warn('[RayPackPicker] Variant не знайдено по SKU:', sku);
        }
      }

	    if (found) {
		    state.variantId = found.id;
		    picker.dataset.resolvedVariantId = found.id;

		    if (!state.customMode) {
			    updateHorizonPrice(found);
		    }

        if (state.isPackMode && state.packItem?.image && !state.customMode) {
          previewPackImage(state.packItem);
        } else if (!state.customMode) {
          switchGalleryImage(found);
        }
      } else {
        state.variantId = null;
	    delete picker.dataset.resolvedVariantId;
      }
    }

    function renderCustomBundle() {
      if (!customBundleEl || !customSlotsEl || !state.customMode || !state.packItem) {
        hideCustomBundle();
        return;
      }

      customBundleEl.hidden = false;
      customSlotsEl.innerHTML = '';

      const packCount = state.customSlots.length;
      const filled = state.customSlots.filter(Boolean).length;

      if (customCountEl) {
        customCountEl.textContent = `${filled} / ${packCount}`;
      }

      state.customSlots.forEach((color, index) => {
        const isEmpty = !color;

        const slot = el('button', {
          type: 'button',
          class: `rpp-custom-slot${isEmpty ? ' rpp-custom-slot--empty' : ''}`,
          'data-slot-index': String(index),
          'aria-label': `${labels.unitAria} ${index + 1}`,
        });

        if (isEmpty) {
          slot.appendChild(el('span', {
            class: 'rpp-custom-slot-plus',
            'aria-hidden': 'true',
          }, '+'));
        } else {
          const variant = state.size ? getSingleVariant(color, state.size) : null;
          const image = getPackColorImage(color) || variant?.featured_image || '';

          const imageWrap = el('span', { class: 'rpp-custom-slot-img-wrap' });

          if (image) {
            imageWrap.appendChild(el('img', {
              src: image,
              alt: color,
              class: 'rpp-custom-slot-img',
              loading: 'lazy',
              width: '120',
              height: '150',
            }));
          } else {
            imageWrap.appendChild(createColorFallback(color));
          }

          slot.appendChild(imageWrap);
          slot.appendChild(el('span', { class: 'rpp-custom-slot-name' }, color));
          slot.appendChild(el('span', { class: 'rpp-custom-slot-edit', 'aria-hidden': 'true' }, '✎'));
        }

        slot.addEventListener('click', () => openCustomModal(index));
        customSlotsEl.appendChild(slot);
      });
    }

    function hideCustomBundle() {
      if (!customBundleEl) return;

      customBundleEl.hidden = true;

      if (customSlotsEl) customSlotsEl.innerHTML = '';
      if (customCountEl) customCountEl.textContent = '0 / 0';
    }

    function normalizeCustomSlotsForSize() {
      if (!state.customMode || !state.size) return;

      const availableColors = getAvailableColorsForSize(state.size);

      if (!availableColors.length) {
        state.customSlots = state.customSlots.map(() => null);
        return;
      }

      state.customSlots = state.customSlots.map((color) => {
        if (color && isColorAvailableForSize(color, state.size)) return color;
        return null;
      });
    }

    function openCustomModal(index) {
      if (!modalEl || !state.customMode || !state.size) return;

      state.activeCustomSlot = index;
      state.modalSelectedColor = state.customSlots[index] || getAvailableColorsForSize(state.size)[0] || null;

      renderCustomModal();

      modalEl.hidden = false;
      modalEl.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rpp-modal-open');
    }

    function closeCustomModal() {
      if (!modalEl) return;

      modalEl.hidden = true;
      modalEl.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rpp-modal-open');
    }

    function renderCustomModal() {
      const color = state.modalSelectedColor;
      const variant = color && state.size ? getSingleVariant(color, state.size) : null;

      if (modalSlotLabelEl) {
        modalSlotLabelEl.textContent = labels.unitLabel;
      }

      if (modalColorLabelEl) {
        modalColorLabelEl.textContent = color || '—';
      }

      if (modalImageEl) {
        const wrap = modalImageEl.closest('.rpp-modal-image-wrap');
        const modalImage = getPackColorImage(color) || variant?.featured_image || '';

        if (modalImage) {
          modalImageEl.src = modalImage;
          modalImageEl.alt = color || '';
          wrap?.classList.remove('is-empty');
        } else {
          modalImageEl.removeAttribute('src');
          modalImageEl.alt = '';
          wrap?.classList.add('is-empty');
        }
      }

      renderModalColors();
    }

    function renderModalColors() {
      if (!modalColorsEl) return;

      modalColorsEl.innerHTML = '';

      colors.forEach((color) => {
        const available = state.size && isColorAvailableForSize(color, state.size);
        const btn = createRoundSwatchButton(color, 'rpp-modal-color', 'rpp-modal-color-inner');

        btn.disabled = !available;
        btn.classList.toggle('is-unavailable', !available);

        if (state.modalSelectedColor === color) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        }

        btn.addEventListener('click', () => {
          if (!available) return;

          state.modalSelectedColor = color;
          renderCustomModal();
        });

        modalColorsEl.appendChild(btn);
      });
    }

    function bindModalEvents() {
      if (!modalEl) return;

      modalEl.querySelectorAll('[data-rpp-modal-close]').forEach((node) => {
        node.addEventListener('click', closeCustomModal);
      });

      if (modalApplyBtn) {
        modalApplyBtn.addEventListener('click', () => {
          if (!state.customMode || !state.modalSelectedColor) return;

          if (!isColorAvailableForSize(state.modalSelectedColor, state.size)) {
            showError(labels.colorUnavailable);
            return;
          }

          state.customSlots[state.activeCustomSlot] = state.modalSelectedColor;

          closeCustomModal();
          renderCustomBundle();
          previewCustomPackImage();
          updateAtcState();
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modalEl.hidden) {
          closeCustomModal();
        }
      });
    }

    function previewCustomPackImage() {
      const firstColor = state.customSlots.find(Boolean);
      const variant = firstColor && state.size ? getSingleVariant(firstColor, state.size) : null;

      if (variant) {
        switchGalleryImage(variant);
      } else if (state.packItem?.image) {
        previewPackImage(state.packItem);
      }
    }

    function getAvailableColorsForSize(size) {
      if (!size) return [];

      return colors.filter((color) => isColorAvailableForSize(color, size));
    }

    function isColorAvailableForSize(color, size) {
      const variant = getSingleVariant(color, size);
      return !!(variant && variant.available);
    }

    function getSingleVariant(color, size) {
      return singleVariantMap.get(buildVariantKey(color, size)) || null;
    }

    function getPackColorImage(color) {
      if (!color) return '';

      const key = String(color).trim();

      return packColorImageMap[key] || '';
    }

    function buildVariantKey(color, size) {
      return `${String(color || '').trim()}::${String(size || '').trim()}`;
    }

    function getSinglePreviewVariant(color) {
      if (!color) return null;

      return (
        variants.find((variant) => variant.option1 === color && formatLabelsMatch(variant.option3, SINGLE_LABEL) && variant.available) ||
        variants.find((variant) => variant.option1 === color && formatLabelsMatch(variant.option3, SINGLE_LABEL))
      );
    }

    function getSkuFromPackItem(item, size) {
      if (!item || !size) return '';

      const fields = SIZE_SKU_FIELDS_MAP[size];

      if (!fields || !fields.length) return '';

      for (const field of fields) {
        const sku = item[field];

        if (sku != null && String(sku).trim() !== '') {
          return String(sku).trim();
        }
      }

      return '';
    }

    function previewPackImage(item) {
      if (!item || !item.image) return;

      switchGalleryImage({
        featured_image: item.image,
        featured_media_id: null,
        force_direct_preview: true,
      });
    }

    function updateHorizonPrice(variant, item = state.packItem, formatLabel = state.format) {
      if (!variant) return;

      const productSection = picker.closest('[id^="shopify-section-"]') || picker.closest('section') || document;
      const productPrice = productSection.querySelector('product-price') || document.querySelector('product-price');

      if (!productPrice) {
        console.warn('[RayPackPicker] product-price not found.');
        return;
      }

      const priceContainer = productPrice.querySelector('[ref="priceContainer"]');

      if (!priceContainer) {
        console.warn('[RayPackPicker] priceContainer not found.');
        return;
      }

      const regularWrap = priceContainer.querySelector('.price__regular');
      const saleWrap = priceContainer.querySelector('.price__sale');

      const regularPriceEl = regularWrap ? regularWrap.querySelector('.price') : null;
      const salePriceEl = saleWrap ? saleWrap.querySelector('.price-item--sale.price, .price') : null;
      const comparePriceEl = saleWrap ? saleWrap.querySelector('.compare-at-price') : null;

      const packPricing = getPackPricing(variant, formatLabel, item);
      const usesPackDiscount = packPricing.discountPercent > 0;
      const nativeHasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      const hasDiscount = usesPackDiscount || nativeHasDiscount;
      const packCount = getCurrentPackCount();
      const showPackPriceTopLine = state.isPackMode && packCount > 1;

      const displayPrice = usesPackDiscount ? packPricing.finalPrice : Number(variant.price) || 0;
      const displayCompare = usesPackDiscount
        ? packPricing.basePrice
        : nativeHasDiscount
          ? Number(variant.compare_at_price) || 0
          : 0;

      const priceText = formatMoney(displayPrice, meta.money_format);
      const packPriceText = priceText;
      const compareText = hasDiscount ? formatMoney(displayCompare, meta.money_format) : '';

      if (hasDiscount) {
        if (regularWrap) regularWrap.classList.add('price__hidden');
        if (saleWrap) saleWrap.classList.remove('price__hidden');

        if (salePriceEl) salePriceEl.textContent = packPriceText;
        if (regularPriceEl) regularPriceEl.textContent = packPriceText;

        if (comparePriceEl) comparePriceEl.textContent = compareText;
      } else {
        if (saleWrap) saleWrap.classList.add('price__hidden');
        if (regularWrap) regularWrap.classList.remove('price__hidden');

        if (regularPriceEl) regularPriceEl.textContent = packPriceText;
        if (salePriceEl) salePriceEl.textContent = packPriceText;
        if (comparePriceEl) comparePriceEl.textContent = '';
      }

      updateSaleBadge(productPrice, variant, packPricing);
      updateTopUnitPrice(productPrice, priceContainer, displayPrice, packCount, showPackPriceTopLine);
      updatePackPriceExtras(productPrice, variant, packPricing);
    }

    function updateTopUnitPrice(productPrice, priceContainer, displayPrice, packCount, shouldShow) {
      if (!productPrice || !priceContainer) return;

      productPrice.querySelectorAll('[data-rpp-top-unit-price]').forEach((node) => node.remove());

      productPrice.classList.toggle('rpp-product-pack-price-active', Boolean(shouldShow));

      if (!shouldShow || !packCount || packCount <= 1 || !displayPrice) return;

      const unitPrice = Math.round(displayPrice / packCount);
      const unitEl = document.createElement('span');

      unitEl.className = 'rpp-product-unit-price';
      unitEl.setAttribute('data-rpp-top-unit-price', '');
      unitEl.textContent = `${formatPackMoney(unitPrice)}/${isRu ? 'шт.' : isUk ? 'од.' : 'item'}`;

      const activePriceWrap =
        priceContainer.querySelector('.price__sale:not(.price__hidden)') ||
        priceContainer.querySelector('.price__regular:not(.price__hidden)') ||
        priceContainer.querySelector('.price__sale') ||
        priceContainer.querySelector('.price__regular');

      const badge = productPrice.querySelector('.ray-price-sale-badge');

      if (badge && activePriceWrap && badge.parentElement !== activePriceWrap) {
        activePriceWrap.appendChild(badge);
      }

      priceContainer.appendChild(unitEl);
    }

    function updateSaleBadge(productPrice, variant, packPricing = null) {
      const row = productPrice.querySelector('.ray-price-row');
      if (!row) return;

      let badge = row.querySelector('.ray-price-sale-badge');
      const packDiscountPercent = Number(packPricing?.discountPercent) || 0;
      const nativeHasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      const hasDiscount = packDiscountPercent > 0 || nativeHasDiscount;

      if (!hasDiscount) {
        if (badge) {
          badge.hidden = true;
          badge.textContent = '';
        }
        return;
      }

      const discountPercent = packDiscountPercent > 0
        ? packDiscountPercent
        : Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ray-price-sale-badge';
        row.appendChild(badge);
      }

      badge.hidden = false;
      badge.textContent = `-${formatPercent(discountPercent)}%`;
    }

    function updatePackPriceExtras(productPrice, variant, packPricing = null) {
      if (productPrice) {
        productPrice.querySelectorAll(
          '[data-rpp-pack-price-extra], [data-rpp-pack-unit-inline], [data-rpp-pack-save-row]'
        ).forEach((node) => node.remove());
      }

      const priceSection = picker.querySelector('#rpp-price-section');

      if (!priceSection) return;

      const packCount = getCurrentPackCount();
      const shouldShow = state.isPackMode && packCount > 1 && variant && Number(variant.price) > 0;

      if (!shouldShow) {
        priceSection.hidden = true;
        return;
      }

      let priceWrap = priceSection.querySelector('.rpp-price-wrap');

      if (priceWrap) {
        priceWrap.innerHTML = '';
        priceWrap.hidden = true;
      }

      let saveEl = priceSection.querySelector('[data-rpp-pack-save-row]');

      if (!saveEl) {
        saveEl = document.createElement('div');
        saveEl.className = 'rpp-pack-save-row';
        saveEl.setAttribute('data-rpp-pack-save-row', '');
        priceSection.appendChild(saveEl);
      }

      const pricing = packPricing || getPackPricing(variant, state.format, state.packItem);
      const usesPackDiscount = pricing.discountPercent > 0;

      const price = usesPackDiscount ? pricing.finalPrice : Number(variant.price) || 0;
      const compareAt = usesPackDiscount
        ? pricing.basePrice
        : Number(variant.compare_at_price) || 0;
      const saving = usesPackDiscount
        ? pricing.saving
        : compareAt > price
          ? compareAt - price
          : 0;

      if (saving > 0) {
        saveEl.textContent = isRu
          ? `Выгода за набор ${formatPackMoney(saving)}`
          : isUk
            ? `Вигода за набір ${formatPackMoney(saving)}`
            : `Save ${formatPackMoney(saving)}`;

        saveEl.hidden = false;
        priceSection.hidden = false;
      } else {
        saveEl.textContent = '';
        saveEl.hidden = true;
        priceSection.hidden = true;
      }
    }

    function getPackDiscountPercent(formatLabel = state.format, item = state.packItem) {
      if (!formatLabel || formatLabelsMatch(formatLabel, SINGLE_LABEL)) return 0;

      const directPercent = Number(item?.discount_percent);

      if (Number.isFinite(directPercent) && directPercent > 0) {
        return Math.min(100, directPercent);
      }

      const matchingItem = packItems.find((packItem) => {
        return (
          formatLabelsMatch(packItem.format_label, formatLabel) &&
          Number(packItem.discount_percent) > 0
        );
      });

      const fallbackPercent = Number(matchingItem?.discount_percent);

      if (!Number.isFinite(fallbackPercent) || fallbackPercent <= 0) return 0;

      return Math.min(100, fallbackPercent);
    }

    function getPackPricing(variant, formatLabel = state.format, item = state.packItem) {
      const basePrice = Number(variant?.price) || 0;
      const discountPercent = getPackDiscountPercent(formatLabel, item);
      const saving = discountPercent > 0
        ? Math.round((basePrice * discountPercent) / 100)
        : 0;
      const finalPrice = Math.max(0, basePrice - saving);

      return { basePrice, discountPercent, saving, finalPrice };
    }

    function formatPercent(value) {
      const number = Number(value) || 0;

      return Number.isInteger(number)
        ? String(number)
        : number.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    }

    function getCurrentPackCount() {
      if (!state.isPackMode) return 1;

      const fromFormat = inferPackCountFromLabel(state.format);

      if (fromFormat && fromFormat > 1) {
        return fromFormat;
      }

      const fromSlots = state.customSlots.length;

      if (fromSlots && fromSlots > 1) {
        return fromSlots;
      }

      const fromPackItem = Number(state.packItem?.pack_count);

      if (fromPackItem && fromPackItem > 1) {
        return fromPackItem;
      }

      return 1;
    }

    function inferPackCountFromLabel(label) {
      const match = String(label || '').match(/\d+/);
      const value = match ? Number(match[0]) : 1;

      return value > 1 ? value : 1;
    }

    function formatPackMoney(amount) {
      const value = Math.round((Number(amount) || 0) / 100);

      return `${value} грн`;
    }

    function formatPackSavingMoney(amount) {
      const value = Math.round((Number(amount) || 0) / 100);

      return `−${value}₴`;
    }

    function updateSizeAvailability() {
      sizesEl.querySelectorAll('.rpp-size-btn').forEach((btn) => {
        const size = btn.dataset.size;
        let available = true;

        if (!state.isPackMode && state.color) {
          const variant = variants.find((v) => {
            return (
              v.option1 === state.color &&
              v.option2 === size &&
              formatLabelsMatch(v.option3, state.format || SINGLE_LABEL)
            );
          });

          available = !!(variant && variant.available);
        } else if (state.isPackMode && state.packItem) {
          const sku = getSkuFromPackItem(state.packItem, size);

          if (sku) {
            const variant = variants.find((v) => String(v.sku).trim() === sku);
            available = !!(variant && variant.available);
          } else {
            available = false;
          }
        }

        btn.disabled = !available;
        btn.classList.toggle('is-unavailable', !available);

        if (!available && btn.classList.contains('is-active')) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');

          if (state.size === size) {
            state.size = null;
            state.variantId = null;
            sizeLabelEl.textContent = '';

            if (state.customMode) {
              normalizeCustomSlotsForSize();
              renderCustomBundle();
            }
          }
        }
      });
    }

    function updateAtcState() {
      picker.dataset.resolvedVariantId = state.variantId || '';

      if (state.isAdding) {
        atcBtn.disabled = true;
        atcText.textContent = labels.adding;
        return;
      }

      if (state.customMode) {
        if (!state.packItem) {
          atcBtn.disabled = true;
          atcText.textContent = labels.choosePackButton;
          return;
        }

        if (!state.size) {
          atcBtn.disabled = true;
          atcText.textContent = labels.chooseSize;
          return;
        }

        if (!isCustomPackReady()) {
          atcBtn.disabled = true;
          atcText.textContent = labels.chooseAllColors;
          return;
        }

        atcBtn.disabled = false;
        atcText.textContent = labels.addPackToCart;
        return;
      }

      if (!state.variantId) {
        atcBtn.disabled = true;

        if (!state.size) {
          atcText.textContent = labels.chooseSize;
        } else if (state.isPackMode && !state.packItem) {
          atcText.textContent = labels.choosePackButton;
        } else {
          atcText.textContent = labels.unavailable;
        }

        return;
      }

      const variant = variants.find((v) => v.id === state.variantId);

      if (variant && variant.available) {
        atcBtn.disabled = false;
        atcText.textContent = labels.addToCart;
      } else {
        atcBtn.disabled = true;
        atcText.textContent = labels.soldOut;
      }
    }

    function isCustomPackReady() {
      if (!state.customMode || !state.packItem || !state.size) return false;
      if (!state.customSlots.length) return false;

      return state.customSlots.every((color) => {
        return color && isColorAvailableForSize(color, state.size);
      });
    }

    atcBtn.addEventListener('click', async () => {
      if (atcBtn.disabled) return;

      if (state.customMode) {
        await addCustomPackToCart();
        return;
      }

      if (!state.variantId) return;

      await addReadyVariantToCart(state.variantId);
    });

    async function addReadyVariantToCart(variantId) {
      clearError();

      state.isAdding = true;
      updateAtcState();

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
  id: variantId,
  quantity: 1,
  properties: {
    _ray_pack_type: 'ready',
    _ray_discount_key: `ready-${getCurrentPackCount()}`,
    _ray_bundle_size: String(getCurrentPackCount()),
    _ray_bundle_id: createGroupId(),
    _ray_bundle_title: getDisplayFormatLabel(state.format),
  },
}),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || `HTTP ${res.status}`);
        }

        atcText.textContent = labels.added;

        await refreshCartDrawer();
        openCartDrawer();

        setTimeout(() => {
          state.isAdding = false;
          updateAtcState();
        }, 1500);
      } catch (err) {
        console.error('[RayPackPicker] /cart/add.js:', err);
        showError(err.message || labels.fallbackError);
        state.isAdding = false;
        updateAtcState();
      }
    }

    async function addCustomPackToCart() {
      clearError();

      if (!isCustomPackReady()) {
        showError(labels.chooseColorsForAllUnits);
        updateAtcState();
        return;
      }

      const items = getCustomCartItems();

      if (!items.length) {
        showError(labels.cannotFindVariants);
        updateAtcState();
        return;
      }

      state.isAdding = true;
      updateAtcState();

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || `HTTP ${res.status}`);
        }

        atcText.textContent = labels.added;

        await refreshCartDrawer();
        openCartDrawer();

        setTimeout(() => {
          state.isAdding = false;
          updateAtcState();
        }, 1500);
      } catch (err) {
        console.error('[RayPackPicker] custom /cart/add.js:', err);
        showError(err.message || labels.fallbackError);
        state.isAdding = false;
        updateAtcState();
      }
    }

    function getCustomCartItems() {
      if (!state.customMode || !state.size || !state.packItem) return [];

      const grouped = groupColors(state.customSlots);
      const groupId = createGroupId();
      const packCount =
        inferPackCountFromLabel(state.format) ||
        state.customSlots.length ||
        Number(state.packItem.pack_count) ||
        1;

      const label = getDisplayFormatLabel(state.format || state.packItem.format_label || `Набір ${packCount} шт`);

      return Object.entries(grouped)
        .map(([color, quantity]) => {
          const variant = getSingleVariant(color, state.size);

          if (!variant || !variant.available) return null;

          return {
            id: variant.id,
            quantity,
            properties: {
  _ray_custom_pack: 'true',
  _ray_pack_size: String(packCount),
  _ray_discount_key: `custom-${packCount}`,
  _ray_custom_pack_group: groupId,
  _ray_custom_pack_label: label,

  _ray_bundle_id: groupId,
  _ray_bundle_title: label,
  _ray_bundle_size: String(packCount),
},
          };
        })
        .filter(Boolean);
    }

    function groupColors(slotColors) {
      return slotColors.reduce((acc, color) => {
        if (!color) return acc;
        acc[color] = (acc[color] || 0) + 1;
        return acc;
      }, {});
    }

    async function refreshCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return false;

      const section = drawer.closest('[id^="shopify-section-"]');
      if (!section || !section.id) return false;

      const sectionId = section.id.replace('shopify-section-', '');

      try {
        const url = `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`;

        const res = await fetch(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!res.ok) return false;

        const sections = await res.json();
        const html = sections[sectionId];

        if (!html) return false;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector(`#shopify-section-${cssEscape(sectionId)}`);

        if (!newSection) return false;

        section.replaceWith(newSection);

        return true;
      } catch (err) {
        console.warn('[RayPackPicker] refreshCartDrawer failed:', err);
        return false;
      }
    }

    function openCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');

      if (!drawer) {
        document.querySelector('button[aria-label*="Кошик"], button[aria-label*="Корзина"]')?.click();
        return;
      }

      const dialog = drawer.querySelector('dialog');
      const isAlreadyOpen = !!dialog?.open;

      if (isAlreadyOpen) return;

      if (typeof drawer.toggleDialog === 'function') {
        drawer.toggleDialog();
      } else {
        document.querySelector('button[aria-label*="Кошик"], button[aria-label*="Корзина"]')?.click();
      }
    }

    function switchGalleryImage(source) {
      if (!source) return false;

      const allowDirectPreview = source.force_direct_preview === true;
      const mediaId = source.featured_media_id ? String(source.featured_media_id) : '';
      const imageSrc = source.featured_image || '';

      if (!allowDirectPreview) {
        restoreDirectPreviewImages();
      }

      let switched = false;

      const desktopGallery = document.querySelector('[data-ray-desktop-gallery]');

      if (desktopGallery) {
        let targetThumb = null;

        if (mediaId) {
          targetThumb = desktopGallery.querySelector(`[data-ray-thumb][data-ray-media-id="${cssEscape(mediaId)}"]`);
        }

        if (!targetThumb && imageSrc) {
          const targetBase = getFilenameBase(imageSrc);

          desktopGallery.querySelectorAll('[data-ray-thumb]').forEach((thumb) => {
            if (targetThumb) return;

            const img = thumb.querySelector('img');
            if (!img) return;

            const thumbBase = getFilenameBase(
              img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('srcset') || ''
            );

            if (thumbBase && thumbBase === targetBase) {
              targetThumb = thumb;
            }
          });
        }

        if (targetThumb) {
          targetThumb.click();
          switched = true;
        }
      }

      const mobileGallery = document.querySelector('[data-ray-mobile-gallery]');

      if (mobileGallery) {
        const slideshow = mobileGallery.querySelector('slideshow-component');

        if (slideshow && typeof slideshow.select === 'function') {
          let index = -1;

          if (mediaId) {
            const slide = mobileGallery.querySelector(
              `[data-ray-mobile-slide][data-ray-media-id="${cssEscape(mediaId)}"]`
            );

            if (slide) {
              index = Number(slide.getAttribute('data-ray-mobile-slide'));
            }
          }

          if (index === -1 && imageSrc) {
            const targetBase = getFilenameBase(imageSrc);
            const slideImgs = mobileGallery.querySelectorAll('[data-ray-mobile-slide] img, slideshow-slide img');

            slideImgs.forEach((img, i) => {
              if (index !== -1) return;

              const slideBase = getFilenameBase(
                img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('srcset') || ''
              );

              if (slideBase && slideBase === targetBase) {
                index = i;
              }
            });
          }

          if (index !== -1 && !Number.isNaN(index)) {
            slideshow.select(index);
            switched = true;
          }
        }
      }

      if (!switched && allowDirectPreview && imageSrc) {
        replaceVisibleGalleryImage(imageSrc);
        switched = true;
      }

      return switched;
    }

    function replaceVisibleGalleryImage(imageSrc) {
      const galleries = [
        document.querySelector('[data-ray-desktop-gallery]'),
        document.querySelector('[data-ray-mobile-gallery]'),
      ].filter(Boolean);

      galleries.forEach((gallery) => {
        const images = Array.from(gallery.querySelectorAll('img')).filter((img) => {
          if (img.closest('[data-ray-thumb]')) return false;
          if (img.closest('.slideshow-controls__thumbnail')) return false;
          return true;
        });

        const visibleMainImage =
          images.find((img) => {
            const rect = img.getBoundingClientRect();
            return rect.width > 120 && rect.height > 120;
          }) ||
          images.find((img) => img.closest('slideshow-slide')) ||
          images.find((img) => img.closest('[data-ray-pane]')) ||
          images[0];

        if (!visibleMainImage) return;

        if (!visibleMainImage.dataset.rppOriginalSrc) {
          visibleMainImage.dataset.rppOriginalSrc = visibleMainImage.getAttribute('src') || '';
          visibleMainImage.dataset.rppOriginalSrcset = visibleMainImage.getAttribute('srcset') || '';
          visibleMainImage.dataset.rppOriginalSizes = visibleMainImage.getAttribute('sizes') || '';
        }

        visibleMainImage.dataset.rppDirectPreview = 'true';
        visibleMainImage.setAttribute('src', imageSrc);
        visibleMainImage.removeAttribute('srcset');
        visibleMainImage.removeAttribute('sizes');
      });
    }

    function restoreDirectPreviewImages() {
      document.querySelectorAll('img[data-rpp-direct-preview="true"]').forEach((img) => {
        const originalSrc = img.dataset.rppOriginalSrc || '';
        const originalSrcset = img.dataset.rppOriginalSrcset || '';
        const originalSizes = img.dataset.rppOriginalSizes || '';

        if (originalSrc) {
          img.setAttribute('src', originalSrc);
        }

        if (originalSrcset) {
          img.setAttribute('srcset', originalSrcset);
        } else {
          img.removeAttribute('srcset');
        }

        if (originalSizes) {
          img.setAttribute('sizes', originalSizes);
        } else {
          img.removeAttribute('sizes');
        }

        delete img.dataset.rppDirectPreview;
        delete img.dataset.rppOriginalSrc;
        delete img.dataset.rppOriginalSrcset;
        delete img.dataset.rppOriginalSizes;
      });
    }

    function getFilenameBase(src) {
      if (!src) return '';

      try {
        const firstSrc = String(src).split(',')[0].trim().split(/\s+/)[0].split('?')[0];
        const filename = decodeURIComponent(firstSrc.split('/').pop() || '').toLowerCase();

        return filename
          .replace(/\.(jpe?g|png|webp|gif|avif)$/i, '')
          .replace(/_(master|\d+x\d*|\d*x\d+|small|medium|large|grande|compact|pico|icon|thumb|crop[a-z_]*)$/i, '');
      } catch {
        return '';
      }
    }

    function createRoundSwatchButton(color, buttonClass, innerClass) {
      const swatch = swatchMap[color] || {};
      const hasRealImage = swatch.swatch_image && !NO_IMAGE_PATTERN.test(swatch.swatch_image);

      const btn = el('button', {
        class: buttonClass,
        type: 'button',
        'data-color': color,
        'aria-label': color,
        'aria-pressed': 'false',
        title: color,
      });

      const inner = el('span', { class: innerClass });

      if (hasRealImage) {
        inner.appendChild(el('img', {
          src: swatch.swatch_image,
          alt: color,
          width: '26',
          height: '26',
          loading: 'lazy',
        }));
      } else if (swatch.swatch_color) {
        inner.style.background = swatch.swatch_color;
      } else {
        inner.textContent = String(color).slice(0, 2);
        inner.classList.add(`${innerClass}--text`);
      }

      btn.appendChild(inner);
      return btn;
    }

    function createColorFallback(color) {
      const node = el('span', { class: 'rpp-custom-slot-fallback' });
      const swatch = swatchMap[color] || {};

      if (swatch.swatch_color) {
        node.style.background = swatch.swatch_color;
      } else {
        node.textContent = String(color || '?').slice(0, 2);
      }

      return node;
    }

    function updateFormatTabSavings() {
      formatTabsEl.querySelectorAll('.rpp-format-tab').forEach((tab) => {
        const format = tab.dataset.format || '';
        const saveText = getFormatSaveText(format);
        const displayLabel = getDisplayFormatLabel(format);
        let saveEl = tab.querySelector('.rpp-format-save');

        const savePrefix = getFormatSavePrefix();

        tab.setAttribute('aria-label', saveText ? `${displayLabel}. ${savePrefix} ${saveText}` : displayLabel);

        if (saveText) {
          if (!saveEl) {
            saveEl = el('span', { class: 'rpp-format-save' });
            tab.appendChild(saveEl);
          }

          saveEl.setAttribute('data-save-prefix', savePrefix);
          saveEl.textContent = saveText;
        } else if (saveEl) {
          saveEl.remove();
        }
      });
    }

    function getFormatSaveText(format) {
      if (!format || formatLabelsMatch(format, SINGLE_LABEL)) return '';

      const variant = getFormatSaveVariant(format);
      if (!variant) return '';

      const pricing = getPackPricing(variant, format, null);
      const nativePrice = Number(variant.price) || 0;
      const nativeCompareAt = Number(variant.compare_at_price) || 0;
      const saving = pricing.discountPercent > 0
        ? pricing.saving
        : nativeCompareAt > nativePrice
          ? nativeCompareAt - nativePrice
          : 0;

      if (saving <= 0) return '';

      return formatPackSavingMoney(saving);
    }

    function getFormatSavePrefix() {
      if (isRu) return 'Экономия';
      if (isUk) return 'Економія';
      return 'Save';
    }

    function getFormatSaveVariant(format) {
      const candidates = variants.filter((variant) => {
        return formatLabelsMatch(variant.option3, format);
      });

      if (!candidates.length) return null;

      const byCurrentSize = state.size
        ? candidates.filter((variant) => String(variant.option2 || '') === String(state.size))
        : [];

      const pool = byCurrentSize.length ? byCurrentSize : candidates;

      return (
        pool.find((variant) => variant.available && Number(variant.compare_at_price) > Number(variant.price)) ||
        pool.find((variant) => Number(variant.compare_at_price) > Number(variant.price)) ||
        pool.find((variant) => variant.available) ||
        pool[0] ||
        null
      );
    }

    function getDisplayFormatLabel(format) {
  const value = String(format || '');

  if (formatLabelsMatch(value, SINGLE_LABEL)) {
    return isRu ? '1 шт' : '1 шт';
  }

  if (!isRu) return value;

  return value
    .replace(/Набір/g, 'Набор')
    .replace(/набір/g, 'набор');
}

    function normalizeFormatLabel(value) {
      return String(value || '')
        .trim()
        .replace(/\s+/g, ' ')
        .replace(/Набір/g, 'набор')
        .replace(/набір/g, 'набор')
        .replace(/Набор/g, 'набор')
        .replace(/набор/g, 'набор')
        .toLowerCase();
    }

    function formatLabelsMatch(a, b) {
      return normalizeFormatLabel(a) === normalizeFormatLabel(b);
    }

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function parseJSON(id, fallback) {
    try {
      const node = document.getElementById(id);
      if (!node) return fallback;
      return JSON.parse(node.textContent);
    } catch (err) {
      console.error('[RayPackPicker] JSON parse error #' + id, err);
      return fallback;
    }
  }

  function uniqueOrdered(arr) {
    const seen = new Set();

    return arr.filter((value) => {
      if (value == null || seen.has(value)) return false;
      seen.add(value);
      return true;
    });
  }

  function setActive(container, selector, activeBtn) {
    container.querySelectorAll(selector).forEach((btn) => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });

    activeBtn.classList.add('is-active');
    activeBtn.setAttribute('aria-pressed', 'true');
  }

  function clearActive(container, selector) {
    container.querySelectorAll(selector).forEach((btn) => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
  }

  function el(tag, attrs, text) {
    const node = document.createElement(tag);

    if (attrs) {
      Object.entries(attrs).forEach(([key, value]) => {
        node.setAttribute(key, value);
      });
    }

    if (text != null) {
      node.textContent = text;
    }

    return node;
  }

  function formatMoney(cents, format) {
    if (!format) return (cents / 100).toFixed(2);

    const amount = (cents / 100).toFixed(2);
    const noDecimal = Math.round(cents / 100).toString();
    const withComma = amount.replace('.', ',');

    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', noDecimal)
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimal);
  }

  function createGroupId() {
    return `ray-custom-pack-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  }

  function cssEscape(value) {
    const str = String(value);

    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(str);
    }

    return str.replace(/"/g, '\\"');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();